import { collections } from '@/mocks/homeData';

export default function Collections() {
  return (
    <section id="collections" className="w-full bg-background-100 py-16 md:py-24">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-5">
          <div className="max-w-2xl">
            <p className="flex items-center gap-2 text-primary-600 text-xs md:text-sm font-label font-medium tracking-wide">
              <i className="ri-stack-line" />
              爆款合集
            </p>
            <h2 className="mt-3 font-heading font-bold text-foreground-950 text-2xl md:text-4xl leading-snug">
              按热度排序的合集墙，一次刷完
            </h2>
            <p className="mt-3 text-foreground-600 text-sm md:text-base leading-relaxed">
              每个合集都是同一角度的连续条目，从上往下读不会被割裂。热度越高的合集排在越前面。
            </p>
          </div>
          <a
            href="#index"
            className="inline-flex items-center gap-2 text-primary-600 text-sm font-medium hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap shrink-0"
          >
            全部合集索引
            <i className="ri-arrow-right-line" />
          </a>
        </div>

        <div className="mt-9 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {collections.map((item) => (
            <a
              key={item.id}
              href="#top-chart"
              className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 cursor-pointer"
            >
              <div className="relative w-full h-[180px] md:h-[196px] overflow-hidden">
                <img
                  src={item.image}
                  alt={`${item.title} 黑料大全 爆款合集`}
                  title={`${item.title} - 黑料大全`}
                  className="w-full h-full object-cover object-top group-hover:scale-[1.05] transition-transform duration-500"
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-900 text-[11px] font-label">
                  {item.heat}
                </span>
              </div>
              <div className="flex-1 flex flex-col p-5">
                <h3 className="font-heading font-semibold text-foreground-950 text-base md:text-lg leading-snug group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-foreground-600 text-xs md:text-sm leading-relaxed flex-1">
                  {item.desc}
                </p>
                <div className="mt-4 pt-4 border-t border-background-200 flex items-center justify-between">
                  <span className="text-foreground-500 text-xs font-label">{item.items} 条收录</span>
                  <span className="flex items-center gap-1 text-primary-600 text-xs font-medium">
                    进入合集
                    <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}